module.exports = __webpack_public_path__ + "img/video.809a823e.jpg";